module.exports = __webpack_public_path__ + "static/media/hq-loading-spinner.18552aa9.svg";